/**
 * @generated SignedSource<<7053e506cbf562bf32cb6091fb6bd20b>>
 * @relayHash 5b0bbc6760b27aad56da84e4b51163bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6b46dd63ea1a72fff4f16ef6d7d446567566754a971f81f07555c5ffdef97b3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type csmRequestDetailsQuery$variables = {
  cloudId: string;
  helpCenterId: string;
  issueKey: string;
};
export type csmRequestDetailsQuery$data = {
  readonly customerService: {
    readonly requestByIssueKey: {
      readonly __typename: "CustomerServiceRequest";
      readonly " $fragmentSpreads": FragmentRefs<"formView_csmRequestDetails" | "header_csmRequestDetails">;
    } | {
      readonly __typename: "QueryError";
      readonly " $fragmentSpreads": FragmentRefs<"throwOnQueryError_csmCommon">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type csmRequestDetailsQuery = {
  response: csmRequestDetailsQuery$data;
  variables: csmRequestDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterId",
    "variableName": "helpCenterId"
  },
  {
    "kind": "Variable",
    "name": "issueKey",
    "variableName": "issueKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "question"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "requestByIssueKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "header_csmRequestDetails"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "formView_csmRequestDetails"
                      }
                    ],
                    "type": "CustomerServiceRequest"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "throwOnQueryError_csmCommon"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.requestByIssueKey"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "requestByIssueKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "summary"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "createdOn"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "statusKey"
                  },
                  {
                    "concreteType": "CustomerServiceTemplateForm",
                    "kind": "LinkedField",
                    "name": "templateForm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "CustomerServiceRequestFormDataConnection",
                    "kind": "LinkedField",
                    "name": "formData",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestFormDataEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "textAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "adfAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryRichTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "multiSelectTextAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryMultiSelectField"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/)
                ],
                "type": "CustomerServiceRequest"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c6b46dd63ea1a72fff4f16ef6d7d446567566754a971f81f07555c5ffdef97b3",
    "metadata": {},
    "name": "csmRequestDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "16e221364d92f33fda2a50d88790de87";

export default node;
